import { Injectable, Compiler } from '@angular/core';
import EnvironmentService from '../services/environmentService';
import HttpBase from '../models/httpBase';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { Router } from '@angular/router';

@Injectable()
export class MessageQueService extends HttpBase {
  rqstNbrs: string;
  status: string;
  comment: string;
  cacheControlKey: number;


  constructor(http: Http, router: Router, private environmentService: EnvironmentService, private runtime: Compiler) {
    super(http, router);
  }

  saveRequestNbrs(requestNbrs: string) {
    this.rqstNbrs = requestNbrs;
    localStorage.setItem('requests', this.rqstNbrs);
  }
  saveStateData(stateData: string) {
    localStorage.setItem('stateData', stateData);
  }
  saveTaskListData(taskList: string) {
    localStorage.setItem('taskList', taskList);
  }
  saveOriginalAdmitted(admitted: string) {
    localStorage.setItem('admitted', admitted);
  }
  selectedValue(selection: string) {
    localStorage.setItem('selection', selection);
  }
  selectedJurisdiction(jurisdictionId: string) {
    localStorage.setItem('jurisdictionId', jurisdictionId);
  }
  saveWOData(woData: string) {
    localStorage.setItem('workOrder', woData);
  }
  savejurisdictionFilter(filter: string) {
    localStorage.setItem('jFilter', filter);
  }
  saveSortOrder(sortList: string) {
    localStorage.setItem('sortOrder', sortList);
  }
  saveSortType(sorting: string) {
    localStorage.setItem('sortType', sorting);
  }
  saveStatus(status: string) {
    this.status = status;
    localStorage.setItem('status', this.status);
  }
  saveComment(comment: string) {
    this.comment = comment;
    localStorage.setItem('comment', this.comment);
  }

  // shared methods
  formatDob(dob: string): string {
    dob = new Date(dob).toISOString();
    const date = new Date(dob);
    const day = date.getDate();
    const month = this.getMonth(date);
    const year = date.getFullYear();
    const formattedDt = month + '/' + day + '/' + year;
    return formattedDt;
  }
  setControlKey() { // (configName: string) {
    // this.cacheControlKey = this.getSwitchValue();
    // if (this.cacheControlKey === undefined || this.cacheControlKey === null) {
    //   this.getControlKey(configName) ;
    // } else {
    //   if (this.cacheControlKey === 1) {
        this.runtime.clearCache();
    //   }
    // }
  }
  getSwitchValue(): number {
    const value = localStorage.getItem('cacheControlKey').toLowerCase().trim();
    switch (value) {
      case '1':
        return 1;
      case '0':
        return 0;
      default: return 0;
    }
  }
  getControlKey() { // (configName: string) {
    // this.getCacheControlKey(configName)
    //   .subscribe(
    //     (data) => {
    //       localStorage.setItem('cacheControlKey', data.toString());
    //       if (data === 1) {
             this.runtime.clearCache();
    //       }
    //     });
    // return this.cacheControlKey;
  }
  getCacheControlKey(configName: string): Observable<number> {
    return this.httpGet(`${this.environmentService.cacheControlKeyUrl}configName=${configName}`, false)
      .map((r: Response) => {
        return r.json();
      });
  }
  getMonth(date: Date) {
    const month = date.getMonth() + 1;
    return month < 10 ? '0' + month : month;
  }
  getDay(date: Date) {
    const day = date.getDay() + 1;
    return day < 10 ? '0' + day : day;
  }
}



// WEBPACK FOOTER //
// ./src/services/MessageQueService.ts